import {type DispatchActionType} from '../models/DispatchActionType';
import {type IState} from '../models/IState';
import {type DispatchAction} from '../store';

// Default state data. Required for reducers to work correctly right away.
export const initialState: IState = {
	environment: {
		translated_modal_terms: {},
		plugin: {
			featureSupport: {},
		},
		modalUI: {
			page: 'billing',
			loadingMode: 'finished',
		},
	},
	peachPayOrder: {
		errorMessage: '',
	},
	merchantConfiguration: {
		general: {
			currency: {
				name: 'United States Dollar',
				code: 'USD',
				symbol: '$',
				position: 'left',
				thousands_separator: ',',
				decimal_separator: '.',
				rounding: 'disabled',
				number_of_decimals: 2,
				hidden: false,
			},
		},
		shipping: {
			shippingZones: 0,
		},
		tax: {
			displayPricesInCartAndCheckout: 'excludeTax',
		},
	},
	calculatedCarts: {
		// Standard/Default cart is always the key "0"
		0: {
			needs_shipping: false,
			package_record: {},
			cart: [],
			summary: {
				fees_record: {},
				coupons_record: {},
				gift_card_record: {},
				subtotal: 0,
				total_shipping: 0,
				tax_lines: [],
				total_tax: 0,
				total: 0,
			},
			cart_meta: {
				is_virtual: false,
			},
		},
	},
	paymentConfiguration: {
		selectedGateway: '',
		availableGateways: [],
		gatewayAvailabilityDetails: {},

		gatewayConfigurations: {},
	},
};

/**
 * Returns a action creator to return a specific type of Dispatch Action without processing.
 */
export function createDispatchUpdate<T>(type: DispatchActionType): (payload: T) => DispatchAction<T> {
	return (payload: T) => ({
		type,
		payload,
	});
}
